import React from "react";
import EventsSection from "./Events";

const EventsPage = () => {
  return (
    <main className="home-shell min-h-screen pt-24">
      <section className="home-section pb-2">
        <div className="home-container">
          <div className="home-card-strong p-8 sm:p-10">
            <span className="section-kicker">Community Calendar</span>
            <h1 className="home-title mt-4 text-3xl font-bold sm:text-5xl">Events</h1>
            <p className="mt-4 max-w-3xl text-sm sm:text-base home-muted">
              Stay updated with upcoming contests, workshops, orientation sessions, and completed events from GUBCPC.
            </p>
          </div>
        </div>
      </section>
      <EventsSection />
    </main>
  );
};

export default EventsPage;
